import React, { useEffect } from "react";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { buildCrmOpsDocketPath } from "../../Agent/Crm/navigateToCrmOpsDocket";

/**
 * Legacy "הפניות שלי" list removed — Ops chat lives inside the CRM docket.
 */
export default function AgentMyOperationRequestsPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(buildCrmOpsDocketPath(), { replace: true });
  }, [navigate]);

  return (
    <div
      style={{
        padding: 48,
        display: "flex",
        justifyContent: "center",
        direction: "rtl",
      }}
    >
      <Spin tip="מעביר לדוקט..." />
    </div>
  );
}
